export default __webpack_public_path__ + "locales/pt/DataReassignmentDialog.json?hash=08bf79f81aa8b6c2b1cfe323277f659e";